import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'billingDetailsContainer',
    'billingDetailsInput',
    'form',
    'billingDetailsCheckbox',
    'countryCode',
  ]

  declare billingDetailsContainerTarget: HTMLDivElement
  declare billingDetailsInputTarget: HTMLTextAreaElement
  declare formTarget: HTMLFormElement
  declare billingDetailsCheckboxTarget: HTMLInputElement
  declare countryCodeTarget: HTMLInputElement

  electionBuddyDetailsPerCountry = {
    CA: {
      name: "ElectionBuddy Inc.",
      address: "9622 42 Avenue #210 Edmonton AB CA",
      taxId: "865070783"
    },
    US: {
      name: "ElectionBuddy Inc.",
      address: "5301 S Superstition Mtn. Dr. Suite 104 #137 Gold Canyon AZ US",
      taxId: "98-1050820"
    }
  }

  connect() {
    this.formTarget.addEventListener('submit', this.submit.bind(this))
  }

  submit(event) {
    this.addCompanyDetails()
  }

  public toggleBillingDetails(): void {
    this.billingDetailsContainerTarget.classList.toggle('hide')
  }

  public addCompanyDetails(): void {
    if (!this.billingDetailsCheckboxTarget.checked) {
      this.billingDetailsInputTarget.value = ''
      return
    }

    const ebDetails = this.obtainElectionBuddyDetails()

    const currentValue = this.billingDetailsInputTarget.value
    if (currentValue && !currentValue.includes("ElectionBuddy Inc.")) {
      this.billingDetailsInputTarget.value = `${currentValue}${ebDetails}`
    } else if (!currentValue) {
      this.billingDetailsInputTarget.value = ebDetails
    }
  }

  private obtainElectionBuddyDetails(): string {
    const countryCode = this.countryCodeTarget.value
    const details = this.electionBuddyDetailsPerCountry[countryCode] || this.electionBuddyDetailsPerCountry.CA

    return `\n${details.name}\n${details.address}\nTax ID: ${details.taxId}`
  }
}
